// FILE: src/utils/analytics.js
// Lightweight analytics hooks for search events.
// Plug into your analytics provider by replacing the internals.
// By default this logs to console and pushes to window.dataLayer / window.analytics if present.

import { logDev, warnDev } from "./logger";

export function trackSearchQuery(query, meta = {}) {
  try {
    const payload = { event: 'search_query', query, ...meta, ts: new Date().toISOString() };
    if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'search_query', query, ...meta });
    }
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track('search_query', { query, ...meta });
    }
    logDev('[analytics] search_query', payload);
  } catch (e) {
    warnDev('trackSearchQuery error', e);
  }
}

export function trackSearchSelect(item, meta = {}) {
  try {
    const payload = { event: 'search_select', item, ...meta, ts: new Date().toISOString() };
    if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'search_select', item: item?.id || item?.path || item?.title, ...meta });
    }
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track('search_select', { item, ...meta });
    }
    logDev('[analytics] search_select', payload);
  } catch (e) {
    warnDev('trackSearchSelect error', e);
  }
}
